import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

const pagingStyle = css<{ disabled?: boolean }>`
    padding: 0 !important;
    text-align: center;
    box-sizing: border-box;
    display: inline-block;
    margin: 0 12px !important;
    cursor: pointer;
    background-color: ${p => p.theme.c.whiteOnActive} !important;
    &.button:disabled, &.button.disabled {
        background-color: ${p => p.theme.c.whiteOnActive} !important;
    }
    &.Flip {
        transform: scale(-1, 1);
    }

    svg {
        display: block;
        width: 40px;
        height: 40px;
        path {
            fill: ${p => p.theme.c.active} !important;
        }
    }

    .i-arrowback {
        display: block;
        font-size: 40px;
        color: ${p => p.theme.c.active};
    }

    ${p =>
        p.disabled
            ? css`
                  border-color: ${p.theme.c.disabled} !important;
                  pointer-events: none;
                  .i-arrowback {
                      color: ${p.theme.c.disabled};
                  }
                  svg {
                      path {
                          fill: ${p.theme.c.disabled} !important;
                      }
                  }
              `
            : undefined}
`;

export const PagingButton = styled(Link)<{ disabled?: boolean }>`
    ${pagingStyle}
`;

/** The same button where the page is turned in place rather than navigated to. */
export const PagingAction = styled.button<{ disabled?: boolean }>`
    ${pagingStyle}
`;

export const PageNumber = styled.div`
    display: inline-block;
    line-height: 43px;
    vertical-align: top;
    font-size: 18px;
    font-weight: bold;
    color: ${p => p.theme.c.active};
`;
